// extracted by mini-css-extract-plugin
export default {"main2":"Menu_main2__uLqpF","main":"Menu_main__xC5l0","hidden":"Menu_hidden__qdAKO","visible":"Menu_visible__jDSpP"};